import { useState, type SubmitEvent } from "react";
import { useTranslation } from "react-i18next";
import { renameProject } from "../../api/projectLifecycleApi";
import ErrorNotice from "../../errors/ErrorNotice";
import { useSubmission } from "../../shared/state/useSubmission";
import AppButton from "../../ui/buttons/AppButton";
import Field from "../../ui/forms/Field";
import { FORM_CONTROL_CLASS } from "../../ui/styles/formStyles";
import { useProjects } from "../projectContext";

interface ProjectNameFieldProps {
  projectId: string;
  projectName: string;
  onChanged: () => void;
}

export default function ProjectNameField({ projectId, projectName, onChanged }: ProjectNameFieldProps) {
  const { t } = useTranslation();
  const [name, setName] = useState(projectName);
  const { state, submit, reset } = useSubmission();
  const { reloadProjects } = useProjects();
  const saving = state.status === "submitting";
  const save = (event: SubmitEvent<HTMLFormElement>) => {
    event.preventDefault();
    submit(async () => {
      await renameProject(projectId, name.trim());
      reloadProjects();
      onChanged();
    });
  };
  return (
    <form onSubmit={save} className="space-y-3">
      <Field label={t("projects.settings.name")}>
        {(control) => <input {...control} className={FORM_CONTROL_CLASS} value={name} required disabled={saving} onChange={(event) => { setName(event.target.value); reset(); }} />}
      </Field>
      {state.status === "failed" ? <ErrorNotice error={state.error} /> : null}
      <AppButton type="submit" disabled={saving || name.trim() === "" || name.trim() === projectName}>{t("common.settings.save")}</AppButton>
    </form>
  );
}
